import { render, staticRenderFns } from "./ViewRolesAndPermission.vue?vue&type=template&id=1591d384&scoped=true&"
import script from "./ViewRolesAndPermission.vue?vue&type=script&lang=ts&"
export * from "./ViewRolesAndPermission.vue?vue&type=script&lang=ts&"
import style0 from "./ViewRolesAndPermission.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./ViewRolesAndPermission.vue?vue&type=style&index=1&id=1591d384&scoped=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1591d384",
  null
  
)

export default component.exports